import { useCallback } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';
import { useLastLocation } from 'react-router-last-location';

import { ROUTES } from 'src/routes';

import { useHistory } from './useHistory';

/**
 * Hook that provides a go back function with smart navigation logic
 * @returns A function that navigates back or to root based on context
 */
export const useGoBack = (): (() => void) => {
  const history = useHistory();
  const location = useLocation();
  const lastLocation = useLastLocation();

  const cameFromSharedPage = lastLocation?.pathname.startsWith(ROUTES.SHARED) ?? false;
  const isLastLocationSameAsCurrentLocation = location.pathname === lastLocation?.pathname;

  return useCallback(() => {
    if (
      lastLocation &&
      lastLocation.pathname !== ROUTES.VERIFY_EMAIL_CALLBACK &&
      !cameFromSharedPage &&
      !isLastLocationSameAsCurrentLocation
    ) {
      history.goBack();
    } else {
      history.push(ROUTES.ROOT);
    }
  }, [history, lastLocation, cameFromSharedPage, isLastLocationSameAsCurrentLocation]);
};
